import { QueryClient, dehydrate, hydrate } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  // defaultOptions preservados do App.tsx original (pré-migração)
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 2,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
      },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    // Pré-carrega a página ao passar o mouse / tocar no link: quando o
    // clique acontece os dados já estão no cache e a troca é instantânea.
    defaultPreload: "intent",
    defaultPreloadDelay: 50,
    // Evita que a página anterior fique "congelada": após 150 ms mostra a
    // barra de progresso, sem piscar em trocas rápidas.
    defaultPendingMs: 150,
    defaultPendingMinMs: 0,
    // Desidrata o cache do React Query no SSR e o re-hidrata no navegador —
    // sem isso a página renderizaria no servidor e refaria a busca no
    // cliente, causando flash e hydration mismatch.
    // O tipo Serializable do router não aceita o DehydratedState do React
    // Query (mutationKey é unknown[]); em runtime é JSON puro, então o cast
    // é seguro e localizado.
    dehydrate: () => ({ queryState: dehydrate(queryClient) }) as never,
    hydrate: (dehydrated: unknown) => {
      const state = (dehydrated as { queryState?: unknown })?.queryState;
      if (state) hydrate(queryClient, state as never);
    },
  });

  return router;
};
